import React from 'react'
import { Routes, Route } from 'react-router-dom'
import ScrollToTop from './components/ScrollToTop'
import Navbar from './components/Navbar'
import Footer from './components/Footer'

// Pages
import HomePage from './pages/HomePage'
import ServicesIndexPage from './pages/ServicesIndexPage'
import TrampolinePage from './pages/services/TrampolinePage'
import BelaegningPage from './pages/services/BelaegningPage'
import FundamentPage from './pages/services/FundamentPage'
import GravearbejdePage from './pages/services/GravearbejdePage'
import AboutPage from './pages/AboutPage'
import GalleryPage from './pages/GalleryPage'
import ContactPage from './pages/ContactPage'
import NotFoundPage from './pages/NotFoundPage'
import ForbiddenPage from './pages/ForbiddenPage'

export default function App() {
  return (
    <div className="flex flex-col min-h-screen bg-stone-50 text-stone-900 font-sans selection:bg-amber-500 selection:text-stone-950">
      {/* Scroll restoration on route changes */}
      <ScrollToTop />

      {/* Global Navigation Header */}
      <Navbar />

      {/* Main Content View */}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/ydelser" element={<ServicesIndexPage />} />
          <Route path="/nedgravning-af-trampolin" element={<TrampolinePage />} />
          <Route path="/belaegning" element={<BelaegningPage />} />
          <Route path="/fundament" element={<FundamentPage />} />
          <Route path="/gravearbejde" element={<GravearbejdePage />} />
          <Route path="/om-jt-knudsen" element={<AboutPage />} />
          <Route path="/galleri" element={<GalleryPage />} />
          <Route path="/kontakt" element={<ContactPage />} />
          <Route path="/403" element={<ForbiddenPage />} />
          <Route path="/404" element={<NotFoundPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>

      {/* Global Footer */}
      <Footer />
    </div>
  )
}
